import React from "react";
import { mapaimg } from "../../assets";
import CTAsec from "../../components/CTAsec";
import TitlePages from "../../components/TitlePage";
import FormDiv from "./FormDiv";
import "./index.css";
import { motion } from "framer-motion";

const Contacto = ({ variants }) => {
  return (
    <>
      <motion.div
        className={"transition"}
        initial={{ x: 0 }}
        animate={{ x: "100%" }}
        exit={{ x: 0 }}
        transition={{
          transition: 3,
          type: "spring",
          stiffness: 200,
        }}
      />
      <div className="containerDiv">
        <TitlePages
          title={"Contactate con nosotros"}
          toptitle={"Contacto"}
          variants={variants}
        />
        <FormDiv variants={variants} />
        <img className="mapa" src={mapaimg} alt="Mapa Replace" />
        <CTAsec href={"/contacto#title"} variants={variants} type={"hash"} />
      </div>
    </>
  );
};

export default Contacto;
